export const state = {
  conditionOptions: null,
  symptomOptions: null,
  allergyOptions: null,
  surgeryOptions: null,
  procedureOptions: null,
  userOptions: null,
  patientOptions: null,
  immunizationOptions: null,
  familyHistoryOptions: null,
  socialHistoryOptions: null,
  medicationOptions: null,
  medicalVisitOptions: null,
  supplementOptions: null,
  calendarOptions: null,
  travelHistoryOptions: null,
  diagnosticOptions: null,
  labOptions: null,
}

export const getters = {
  getConditionOptions(state) {
    return state.conditionOptions ? state.conditionOptions : null
  },
  getSymptomOptions(state) {
    return state.symptomOptions ? state.symptomOptions : null
  },
  getAllergyOptions(state) {
    return state.allergyOptions ? state.allergyOptions : null
  },
  getProcedureOptions(state) {
    return state.procedureOptions ? state.procedureOptions : null
  },
  getSurgeryOptions(state) {
    return state.surgeryOptions ? state.surgeryOptions : null
  },
  getUserOptions(state) {
    return state.userOptions ? state.userOptions : null
  },
  getPatientOptions(state) {
    return state.patientOptions ? state.patientOptions : null
  },
  getImmunizationOptions(state) {
    return state.immunizationOptions ? state.immunizationOptions : null
  },
  getFamilyHistoryOptions(state) {
    return state.familyHistoryOptions ? state.familyHistoryOptions : null
  },
  getSocialHistoryOptions(state) {
    return state.socialHistoryOptions ? state.socialHistoryOptions : null
  },
  getMedicationOptions(state) {
    return state.medicationOptions ? state.medicationOptions : null
  },
  getMedicalVisitOptions(state) {
    return state.medicalVisitOptions ? state.medicalVisitOptions : null
  },
  getSupplementOptions(state) {
    return state.supplementOptions ? state.supplementOptions : null
  },
  getCalendarOptions(state) {
    return state.calendarOptions ? state.calendarOptions : null
  },
  getTravelHistoryOptions(state) {
    return state.travelHistoryOptions ? state.travelHistoryOptions : null
  },
  getDiagnosticOptions(state) {
    return state.diagnosticOptions ? state.diagnosticOptions : null
  },
  getLabOptions(state) {
    return state.labOptions ? state.labOptions : null
  },
}

export const mutations = {
  SET_CONDITION_OPTIONS(state, newValue) {
    state.conditionOptions = newValue
  },
  SET_SYMPTOM_OPTIONS(state, newValue) {
    state.symptomOptions = newValue
  },
  SET_ALLERGY_OPTIONS(state, newValue) {
    state.allergyOptions = newValue
  },
  SET_SURGERY_OPTIONS(state, newValue) {
    state.surgeryOptions = newValue
  },
  SET_PROCEDURE_OPTIONS(state, newValue) {
    state.procedureOptions = newValue
  },
  SET_USER_OPTIONS(state, newValue) {
    state.userOptions = newValue
  },
  SET_PATIENT_OPTIONS(state, newValue) {
    state.patientOptions = newValue
  },
  SET_IMMUNIZATION_OPTIONS(state, newValue) {
    state.immunizationOptions = newValue
  },
  SET_FAMILY_HISTORY_OPTIONS(state, newValue) {
    state.familyHistoryOptions = newValue
  },
  SET_SOCIAL_HISTORY_OPTIONS(state, newValue) {
    state.socialHistoryOptions = newValue
  },
  SET_MEDICATION_OPTIONS(state, newValue) {
    state.medicationOptions = newValue
  },
  SET_MEDICAL_VISIT_OPTIONS(state, newValue) {
    state.medicalVisitOptions = newValue
  },
  SET_SUPPLEMENT_OPTIONS(state, newValue) {
    state.supplementOptions = newValue
  },
  SET_CALENDAR_OPTIONS(state, newValue) {
    state.calendarOptions = newValue
  },
  SET_TRAVEL_HISTORY_OPTIONS(state, newValue) {
    state.travelHistoryOptions = newValue
  },
  SET_DIAGNOSTIC_OPTIONS(state, newValue) {
    state.diagnosticOptions = newValue
  },
  SET_LAB_OPTIONS(state, newValue) {
    state.labOptions = newValue
  },
}

export const actions = {
  setConditionOptions({ commit, state }, payload) {
    if (payload) {
      commit('SET_CONDITION_OPTIONS', payload)
      return payload
    }
    return null
  },
  setSymptomOptions({ commit, state }, payload) {
    if (payload) {
      commit('SET_SYMPTOM_OPTIONS', payload)
      return payload
    }
    return null
  },
  setAllergyOptions({ commit, state }, payload) {
    if (payload) {
      commit('SET_ALLERGY_OPTIONS', payload)
      return payload
    }
    return null
  },
  setSurgeryOptions({ commit, state }, payload) {
    if (payload) {
      commit('SET_SURGERY_OPTIONS', payload)
      return payload
    }
    return null
  },
  setProcedureOptions({ commit, state }, payload) {
    if (payload) {
      commit('SET_PROCEDURE_OPTIONS', payload)
      return payload
    }
    return null
  },
  setUserOptions({ commit, state }, payload) {
    if (payload) {
      commit('SET_USER_OPTIONS', payload)
      return payload
    }
    return null
  },
  setPatientOptions({ commit, state }, payload) {
    if (payload) {
      commit('SET_PATIENT_OPTIONS', payload)
      return payload
    }
    return null
  },
  setImmunizationOptions({ commit, state }, payload) {
    if (payload) {
      commit('SET_IMMUNIZATION_OPTIONS', payload)
      return payload
    }
    return null
  },
  setFamilyHistoryOptions({ commit, state }, payload) {
    if (payload) {
      commit('SET_FAMILY_HISTORY_OPTIONS', payload)
      return payload
    }
    return null
  },
  setSocialHistoryOptions({ commit, state }, payload) {
    if (payload) {
      commit('SET_SOCIAL_HISTORY_OPTIONS', payload)
      return payload
    }
    return null
  },
  setMedicationOptions({ commit, state }, payload) {
    if (payload) {
      commit('SET_MEDICATION_OPTIONS', payload)
      return payload
    }
    return null
  },
  setMedicalVisitOptions({ commit, state }, payload) {
    if (payload) {
      commit('SET_MEDICAL_VISIT_OPTIONS', payload)
      return payload
    }
    return null
  },
  setSupplementOptions({ commit, state }, payload) {
    if (payload) {
      commit('SET_SUPPLEMENT_OPTIONS', payload)
      return payload
    }
    return null
  },
  setCalendarOptions({ commit, state }, payload) {
    if (payload) {
      commit('SET_CALENDAR_OPTIONS', payload)
      return payload
    }
    return null
  },
  setTravelHistoryOptions({ commit, state }, payload) {
    if (payload) {
      commit('SET_TRAVEL_HISTORY_OPTIONS', payload)
      return payload
    }
    return null
  },
  setDiagnosticOptions({ commit, state }, payload) {
    if (payload) {
      commit('SET_DIAGNOSTIC_OPTIONS', payload)
      return payload
    }
    return null
  },
  setLabOptions({ commit, state }, payload) {
    if (payload) {
      commit('SET_LAB_OPTIONS', payload)
      return payload
    }
    return null
  },
}
